import Header from './../../../../../Headers/HeaderForAreLoggedIn/index.vue'
import ProgressHUD from './../../../../../ProgressHUD/index.vue'
import GoogleMap from './../../../../../GoogleMap/VueGoogleMap.vue'
import { Helper } from './../../../../../../services'

export default {
  name: 'UserInfo',
  props: [],
  components: {
    Header,
    ProgressHUD,
    GoogleMap,
  },
  data() {
    return {
      user: {
        name: '',
        age: '',
        phone: '',
        address: '',
        country: '',
        location: {
          latitude: null,
          longitude: null,
        },
        facebookLink: '',
        instagramLink: '',
        twitterLink: '',
        googleLink: '',
        linkedinLink: '',
        walletAddress: '',
        walletAddressETH: '',
      },
      countries: null,
      validationMessage: '',
    }
  },
  computed: {
    isWalletAddressETH() {
      // check if walletAddress is empty
      if (this.user.walletAddress === '') return true // walletAddressETH is required
      return false
    },
    isWalletAddressBTH() {
      // check if walletAddressETH is empty
      if (this.user.walletAddressETH === '') return true // walletAddress is required
      return false
    },
  },
  methods: {
    async isValid() {
      return await this.$validator.validateAll('userForm')
    },

    getData() {
      this.user.location.latitude = this.$refs.googleMap.marker.position.lat()
      this.user.location.longitude = this.$refs.googleMap.marker.position.lng()
      this.user.country = this.$refs.selectCountry.value

       console.log("this.project INFO >>>>>>>>>>>>>>>>>>>>>>>>>>>>")
        console.log(this.user, this.$refs.googleMap.marker.position.lat(), this.$refs.googleMap.marker.position.lng())


      return {
        fullName: this.user.name,
        age: this.user.age,
        phone: this.user.phone,
        address: this.user.address,
        country: this.user.country,
        location: {
          latitude: this.user.location.latitude,
          longitude: this.user.location.longitude,
        },
        facebookLink: this.user.facebookLink,
        twitterLink: this.user.twitterLink,
        instagramLink: this.user.instagramLink,
        googleLink: this.user.googleLink,
        linkedinLink: this.user.linkedinLink,
        walletAddress: this.user.walletAddress,
        walletAddressETH: this.user.walletAddressETH,
      }
    },

    setData(user) {
      if (user) {
        this.user.name = user.fullName
        this.user.age = user.age
        this.user.phone = user.phone
        this.user.address = user.address
        this.user.country = user.country
        this.user.location.latitude = user.location.latitude
        this.user.location.longitude = user.location.longitude
        this.user.facebookLink = user.facebookLink
        this.user.instagramLink = user.instagramLink
        this.user.twitterLink = user.twitterLink
        this.user.googleLink = user.googleLink
        this.user.linkedinLink = user.linkedinLink
        this.user.walletAddress = user.walletAddress
        this.user.walletAddressETH = user.walletAddressETH

        this.$refs.selectCountry.value = user.country

        this.$refs.googleMap.setPosition(
          user.location.latitude,
          user.location.longitude
        )
      }
    },
  },
  created() {
    this.countries = require('./../../../../../../data/country.js')
  },
}



// WEBPACK FOOTER //
// ./src/components/Account/Permissions/Roles/BaseComponents/UserInfo/UserInfo.component.js